<script>
import moment from 'moment';

module.exports = {
  template: '#tradeplan-template',
  computed: {
    cars: function() {
      let cars = this.$store.state.cars;

      cars.active = cars.active.map(car => {
        car.previous_maintenance_date = car.maintenances.length ? car.maintenances[0].date + 'Z' : '-';

        return car;
      });

      return cars;
    }
  }
};
</script>